<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="18">
        <!-- 游戏信息 -->
        <el-card shadow="never">
          <div class="game_title theme">{{ info.content.title }}</div>
          <div class="game-info clearfix">
            <div class="img pull-left">
              <img :src="info.content.image" :alt="info.content.title">
            </div>
            <div class="meta pull-left">
              <div class="tag" v-for="(item, idx) in info.content.infos" :key="idx">
                <span class="key">{{ item.key }}</span>
                <span class="value" :class="{'theme': idx==0}">{{ item.value }}</span>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 买家描述 -->
        <el-card shadow="never" class="mt10" :body-style="{'padding-bottom': '4px'}">
          <div class="trad-title">卖家描述</div>
          <div class="trd-content">{{ info.content.content }}</div>

          <div class="trad-title">角色截图</div>
          <div class="trd-imgs">
            <a class="trd-img" :href="item" v-for="(item, idx) in info.content.imgs" :key="idx">
              <img :src="item" alt="">
            </a>
          </div>
        </el-card>

        <el-card shadow="never" class="mt10" :body-style="{'padding': '10px'}">
          <template slot="header">
            <span class="theme size16">热门交易</span>
          </template>

          <ul class="trade-list small clearfix">
            <li class="trade-item clearfix" v-for="(item, idx) in hotTradeList" :key="idx">
              <router-link :to="item.id" :title="item.title" class="img pull-left">
                <img :src="item.image" :alt="item.title">
              </router-link>

              <div class="meta pull-left">
                <router-link :to="item.id" :title="item.title" class="title">
                  {{ item.title }}
                  <span class="theme price">{{ item.price }}</span>
                </router-link>
                <div class="desc">{{ item.desc }}</div>
                <div class="time">{{ item.time }}</div>
              </div>

              <div class="button pull-right">
                <router-link class="link" :to="item.id" :title="item.title">查看详情</router-link>
              </div>
            </li>
          </ul>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="never">
          <template slot="header">
            <span class="theme size16">相关资讯</span>
          </template>

          <list />
        </el-card>

        <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">最新开服</span>
          </template>

          <hot-list />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    let info = null
    const id = this.$route.params.id
    if(this.$route.query.type == 1) {
      info = this.$datas.newTradeList.find(c => c.id == `/trade/${id}/`)
    } else {
      info = this.$datas.hotTradeList.find(c => c.id == `/trade/${id}/`)
    }
    return {
      info: info,
      hotTradeList: this.$datas.hotTradeList,
    }
  }
}
</script>

<style lang="scss">
.game_title {
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: bold;
}
.game-info {
  .img {
    width: 100px;
    height: 100px;
  }
  .meta {
    margin-left: 15px;
    .tag {
      margin-bottom: 4px;
      color: #565656;
      .key {
        width: 75px;
        display: inline-block;
        margin-right: 15px;
      }
    }
  }
}

.trad-title {
  color: var(--theme);
  font-size: 16px;
  margin-bottom: 10px;
}
.trd-imgs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .trd-img {
    display: block;
    width: 49%;
    margin-bottom: 17px;
  }
}
.trd-content {
  padding: 5px 15px 15px 15px;
}
</style>
